import React from 'react'
import { Form, Input } from 'semantic-ui-react'

import { QuestionBuilderConsumer } from 'organisms/QuestionBuilderCard'

export function SliderQuestionInput() {
  return (
    <QuestionBuilderConsumer>
      {({ handleFieldChange, question }) => {
        return (
          <Form.Group widths="equal" className="field">
            <Form.Field>
              <label>Min score</label>
              <Input
                data-testid="slider-min-label"
                className="large"
                required
                value={question.leftSideLabel}
                onChange={handleFieldChange('leftSideLabel')}
              />
            </Form.Field>
            <Form.Field>
              <label>Max score</label>
              <Input
                data-testid="slider-max-label"
                className="large"
                required
                value={question.rightSideLabel}
                onChange={handleFieldChange('rightSideLabel')}
              />
            </Form.Field>
          </Form.Group>
        )
      }}
    </QuestionBuilderConsumer>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SliderQuestionInput/index.js